import React from 'react';
import { Helmet } from "react-helmet";
import { Container, Col, Row } from 'reactstrap';
import axios from 'axios';
import { Document, Page } from 'react-pdf';
import { Menu } from 'antd';
import Loading from '../../../components/Loading';
import { cloudFrontCdnUrl, s3SupportDocs } from '../../../config/properties';
import './relnotes.scss';
import NFButton from '../../../components/primitives/NFButton';

export default class relNotes extends React.Component {
  state = {
    loading: true,
    numPages: null,
    pageNumber: 1,
    nFile: null,
    folderNames: [],
  };

  async componentDidMount() {
    window.scrollTo({ top: 0 });
    try {
      const xml = await axios.get(`${cloudFrontCdnUrl}`);
      const folderNames = await this.getS3FolderFiles('', xml);
      this.setState({
        folderNames,
      });
    } catch (error) {
      console.error(error);
    }
  }

  onDocumentLoadSuccess = async ({ numPages }) => {
    await this.setState({
      numPages,
    });
  };

  getS3FolderFiles = (s3FolderName, xmlText) => {
    this.setState({ loading: true });

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText.data, 'text/xml');
    const nRelNotes = [];
    let folderNames = [];

    for (let i = 0; i < xmlDoc.getElementsByTagName('Contents').length; i += 1) {
      const xmlNode = xmlDoc.getElementsByTagName('Contents')[i].getElementsByTagName('Key')[0].textContent;
      if (xmlNode.endsWith('ReleaseNotes.pdf')) {
        nRelNotes.push(xmlNode);
      }
    }

    nRelNotes.sort().reverse();
    if (nRelNotes.length > 0) {
      folderNames = nRelNotes.map(nFile => (
        <Menu.Item key={nFile} title={nFile.split('.pdf')[0]}>
          {nFile.split('.pdf')[0]}
        </Menu.Item>
      ));
    }

    this.setState({
      loading: false,
      nFile: folderNames[0] ? folderNames[0].key : null,
    });

    return folderNames;
  };

  changePage = offset => this.setState(prevState => ({
    pageNumber: prevState.pageNumber + offset,
  }));

  previousPage = () => this.changePage(-1);
  nextPage = () => this.changePage(1);

  handleClick = e => {
    this.setState({ nFile: e.key, numPages: null, pageNumber: 1 });
  };

  _onClick = () => {
    const href = `${s3SupportDocs}/${this.state.nFile}`;
    window.open(href, "_blank");
  };

  render() {
    const { numPages, pageNumber, nFile, folderNames, loading } = this.state;
    return (
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Release Notes Page</title>
          <meta name="description" content="" />
          <meta name="keywords" content="" />
        </Helmet>
        <div className="relNotes-bottom">
          <Col xs={1} />
          <Row>
            <div style={{ width: 400 }}>
              <h1 className="relNotes-header">Release Notes</h1>
            </div>
            <div className="relNotes-header">
              To enable links in the document please open or download the pdf.
            </div>
          </Row>

          <div className="relNotes-wrapper">
            <div>
              <Menu
                onClick={this.handleClick}
                style={{ width: 300 }}
                selectedKeys={[nFile]}
                mode="inline"
                title={[nFile]}
              >
                {folderNames}
              </Menu>
            </div>
            {!loading && (
              <div>
                <a href={`${s3SupportDocs}/${nFile}`} target="_blank" rel="noopener noreferrer">
                  <Document
                    file={`${cloudFrontCdnUrl}/${nFile}`}
                    onLoadSuccess={this.onDocumentLoadSuccess}
                  >
                    <Page pageNumber={pageNumber} />
                  </Document>
                </a>

                {numPages && (
                  <div>
                    <p>
                      Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
                    </p>
                    <div className="relNotes-button-container">
                      <NFButton
                        className="nf-button relNotes-button nf-button--gray"
                        type="button"
                        disabled={pageNumber <= 1}
                        onClick={this.previousPage}
                      >
                        Previous
                      </NFButton>
                      <NFButton
                        className="nf-button relNotes-button nf-button--gray"
                        type="button"
                        disabled={pageNumber >= numPages}
                        onClick={this.nextPage}
                      >
                        Next
                      </NFButton>
                      <button className="relNotes-button" onClick={this._onClick} title={nFile}>Open / Download PDF</button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {loading && <Loading test="oof" />}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/static/relnotes/relnotes.jsx